import React, {useState} from 'react'
import Translation from '../global/Translation'
import LocalizedLink from '../global/LocalizedLink'
import Button from '../global/Button'
import slide from '../../assets/img/home/home-slide.png'
import CTS_V2 from '../../assets/img/banners-v2/CTS_V2.png'
import Outlet_V2 from '../../assets/img/banners-v2/Outlet_V2.png'
import Tablas_V2 from '../../assets/img/banners-v2/Tablas_V2.png'
import outlet from '../../assets/img/home/home-slide-outlet.png'
import mall from '../../assets/img/home/mall-slide.png'
import promoNaturalStoneV2 from '../../assets/img/banners-exclusive-promo-natural-stone/promo_natural_stone_v2.png'
import { injectIntl } from 'react-intl'
import LastBoughtProductsContainer from '../products/LastBoughtProductsContainer'
import Spinner from '../global/Spinner'
import ChangeLogHomeNews from '../changelog/ChangeLogHomeNews'
import Alerts from '../alerts/Alerts'
import MenuContainer from '../header/MenuContainer'
import ProductsForYouContainer from "../products/ProductsForYouContainer";
import MallPreviewContainer from "../products/MallPreviewContainer";
import BannerDekton from '../banners/banner-dekton/BannerDekton'
import Banner1Mktools from '../../assets/img/banners-mktools/Promo_Card_1.png'
import Banner2Mktools from '../../assets/img/banners-mktools/Promo_Card_2.png'
import Banner3Mktools from '../../assets/img/banners-mktools/Promo_Card_3.png'
import BannerWorkwear from '../../assets/img/banners-mktools/cosentino-workwear.jpg'
import BannerSupplies from '../../assets/img/banners-mktools/cosentino-supplies.jpg'
import BannerRockMaster from '../banners/banner-rockmaster/BannerRockMaster'
import BannerSuma from '../banners/banner-suma/BannerSuma'
import BannerSilestoneXM from '../banners/banner-silestone-xm/BannerSilestoneXM'
import BannerEclosBrand from '../banners/banner-eclos-brand/BannerEclosBrand'
import Slider from 'react-slick'
import BannerHomeCatalogNaturalStone from '../banners/banner-natural-stone/BannerHomeCatalogNaturalStone'
import BannerBathroomDaysPromotion from '../banners/banner-bathroom-days-promo/BannerBathroomDaysPromotion'

class HomeV2 extends React.Component {
    state = {hasMall: true}

    componentDidMount() {
        if (this.props.selectedCenter === 7777) this.props.goLowes(this.props.userType, this.props.intl)
        else if (this.props.isIkeaCenter) this.props.goIkea(this.props.intl)

        // const slider = document.getElementsByClassName('slick-slider')[0]
        // slider.addEventListener("drag", (e) => {e.stopPropagation()}, false)

        // document.addEventListener('DOMContentLoaded', (event) => {
        //     const elements = document.getElementsByClassName('slick-slider');
        //     for (let element of elements) {
        //         element.addEventListener('dragstart', (e) => {
        //             e.stopPropagation();
        //         });
        //     }
        // });
    }

    slickSettings = {
        arrows: false,
        swipeToSlide: true,
        dots: false,
        speed: 750,
        autoplaySpeed: 4000,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        variableWidth: false
    }

    CustomSlide = (props) => {
        const [isMovin, setIsMovin] = useState(false)

        const { id, bannerUrl, bannerTitle, bannerText } = props;
        const handleClick = e => {
            if (isMovin) e.preventDefault()
        }

        return (
            <div className="col-12"
                 onDragStart={e => {
                     e.preventDefault()
                 }}
                 onMouseDown={e => {
                     if (isMovin===true) setIsMovin(false)
                 }}
                 onMouseMove={e => {
                     if (isMovin===false) setIsMovin(true)
                 }}
            >
                <LocalizedLink routeId="ROUTE_PROMOTION_LANDING"b
                               params={{ promotionId: id }}
                               onClick={handleClick}
                >
                    <div>
                        <img src={bannerUrl} style={{ width: '100%' }} alt="" className="" />
                        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '80%', fontSize: '1vw' }}>
                            <div dangerouslySetInnerHTML={{ __html: bannerTitle }} />
                            <div dangerouslySetInnerHTML={{ __html: bannerText }} />
                        </div>
                    </div>
                </LocalizedLink>
            </div>
        );
    }

    render() {

        let homeSlides = [
                {
                    title: <Translation id="tables" defaultMessage="Slabs" />,
                    colorTitle: 'white',
                    subtitle: <Translation id="ask_about_stock" defaultMessage="Check Stock of your Usual Center" />,
                    colorSubtitle: 'white',
                    buttonText: <Translation id="shop_here" defaultMessage="Buy here" />,
                    buttonColor: 'white',
                    backgroundImage: slide,
                    backgroundImageLazy: slide,
                    routeId: 'ROUTE_CATALOG',
                    queryString: '?type[0]=SLAB',
                    params: { outlet: '' },
                    extraClassName: 'card-wide card-tall',
                    dataQas: ''
                },
                {
                    title: <Translation id="tables" defaultMessage="Slabs" />,
                    colorTitle: 'white',
                    subtitle: <Translation id="ask_about_stock" defaultMessage="Check Stock of your Usual Center" />,
                    colorSubtitle: 'white',
                    buttonText: <Translation id="shop_here" defaultMessage="Buy here" />,
                    buttonColor: 'white',
                    backgroundImage: mall,
                    backgroundImageLazy: mall,
                    routeId: 'ROUTE_CATALOG',
                    queryString: '?type[0]=SLAB',
                    params: { outlet: '' },
                    extraClassName: '',
                    dataQas: ''
                },
                {
                    title: <Translation id="cosentino_outlet" defaultMessage="Cosentino Outlet" />,
                    colorTitle: 'white',
                    subtitle: <Translation id="shop_here" defaultMessage="Buy here" />,
                    colorSubtitle: 'white',
                    buttonText: <Translation id="shop_here" defaultMessage="Buy here" />,
                    buttonColor: 'white',
                    backgroundImage: outlet,
                    backgroundImageLazy: outlet,
                    routeId: 'ROUTE_CATALOG',
                    queryString: '?type[0]=SLAB',
                    params: { outlet: 'outlet' },
                    extraClassName: '',
                    dataQas: ''
                },

            ]
        
            if (this.props.isPriorityCustomerForEclos || this.props.isAustralianCenter || this.props.canViewEclosBrandInEurope || this.props.isSelectedCenterAvailableToBuyEclosProducts) {
                homeSlides[0] = {
                    customComponent: (
                        <BannerEclosBrand
                            isHomeSlideView={true}
                            isPriaorityCustomer={this.props.isPriorityCustomerForEclos}
                            isAustralianCenter={this.props.isAustralianCenter}
                            canViewEclosBrandInEurope={this.props.canViewEclosBrandInEurope}
                            isSelectedCenterAvailableToBuyEclosProducts={this.props.isSelectedCenterAvailableToBuyEclosProducts}
                        />
                    ),
                    extraClassName: 'custom-component card-wide card-tall'
                }
            } else if (this.props.canViewNaturalStoneSection) {
                homeSlides[0] = { customComponent: <BannerHomeCatalogNaturalStone /> }
            } else {
                homeSlides[0].title = <Translation id="CTS_V2_TXT" defaultMessage="Slabs" />
                homeSlides[0].subtitle = <Translation id="CTS_V2_TXT_2" defaultMessage="Check Stock of your Usual Center" />
                homeSlides[0].buttonText = <Translation id="access" defaultMessage="Buy here" />
                homeSlides[0].backgroundImage = CTS_V2
                homeSlides[0].backgroundImageLazy = CTS_V2
                homeSlides[0].queryString = ''
                homeSlides[0].params = { outlet: '' }
                homeSlides[0].routeId = 'ROUTE_CUT_TO_SIZE'
                homeSlides[0].dataQas = 'home_hero-cut-to-size-buy-here-button'
            }

            // Slide 1
            homeSlides[1].title = this.props.isAustralianCenter
                ? <Translation id="TABLAS_V2_NO_SL_TXT" defaultMessage="Dekton and Sensa" />
                : <Translation id="TABLAS_V2_TXT" defaultMessage="Slabs" />

            homeSlides[1].subtitle = <Translation id="tables" defaultMessage="Slabs" />
            homeSlides[1].buttonText = <Translation id="access" defaultMessage="Buy here" />
            homeSlides[1].backgroundImage = Tablas_V2
            homeSlides[1].backgroundImageLazy = Tablas_V2
            homeSlides[1].queryString = '?type[0]=SLAB'
            homeSlides[1].params = { outlet: '' }
            homeSlides[1].routeId = 'ROUTE_CATALOG'
            homeSlides[1].dataQas = 'home_hero-slabs-buy-here-button'

            // Slide 2
            if (this.props.canViewBathroomDayPromotion && (this.props.canViewBathroomDayPromotion.inPortugal || this.props.canViewBathroomDayPromotion.inSpain)) {
                homeSlides[2] = {
                    customComponent: <BannerBathroomDaysPromotion canViewBathroomDayPromotion={this.props.canViewBathroomDayPromotion} />
                }
            } else {
                homeSlides[2].title = <Translation id="OUTLET_V2_TXT" defaultMessage="Cosentino Outlet" />
                homeSlides[2].subtitle = <Translation id="cosentino_outlet" defaultMessage="Cosentino Outlet" />
                homeSlides[2].buttonText = <Translation id="view_promotion" defaultMessage="Buy here" />
                homeSlides[2].backgroundImage = Outlet_V2
                homeSlides[2].backgroundImageLazy = Outlet_V2
                homeSlides[2].queryString = '?type[0]=SLAB'
                homeSlides[2].params = { outlet: 'outlet' }
                homeSlides[2].routeId = 'ROUTE_CATALOG'
                homeSlides[2].dataQas = 'home_hero-outlet-buy-here-button'
            }

        if (this.props.canViewMktools && !this.props.isWarehouse) {
             homeSlides[0] = {
                 title: <Translation id="marketing_tools" defaultMessage="Marketing Tools" />,
                 colorTitle: 'white',
                 subtitle: '',
                 buttonText: <Translation id="shop_here" defaultMessage="Buy here" />,
                 backgroundImage: Banner1Mktools,
                 backgroundImageLazy: Banner1Mktools,
                 routeId: 'ROUTE_CATALOG',
                 queryString: '?webHeading[0]=MK',
                 params: { outlet: '' },
                 buttonColor: 'white',
                 extraClassName: ''
             }
             homeSlides[1] = {
                 title: <Translation id="showroom" defaultMessage="Showroom" />,
                 colorTitle: 'white',
                 subtitle: '',
                 buttonText: <Translation id="shop_here" defaultMessage="Buy here" />,
                 backgroundImage: Banner2Mktools,
                 backgroundImageLazy: Banner2Mktools,
                 routeId: 'ROUTE_CATALOG',
                 queryString: '?webHeading[0]=SH',
                 params: { outlet: '' },
                 buttonColor: 'white',
                 extraClassName: ''
             }
             delete homeSlides[2]
        }

        if (this.props.canViewMktools && this.props.isWarehouse) {
            homeSlides[0] = {
                title: <Translation id="WORKWEAR" defaultMessage="Workwear" />,
                colorTitle: 'white',
                subtitle: '',
                buttonText: <Translation id="shop_here" defaultMessage="Buy here" />,
                backgroundImage: BannerWorkwear,
                backgroundImageLazy: BannerWorkwear,
                routeId: 'ROUTE_CATALOG',
                queryString: '?typeId[0]=13',
                params: { outlet: '' },
                buttonColor: 'white',
                extraClassName: 'card-wide card-tall background-position-center'
            }
            homeSlides[1] = {
                title: <Translation id="WAREHOUSE_SUPPLIES" defaultMessage="warehouse supplies" />,
                colorTitle: 'white',
                subtitle: '',
                buttonText: <Translation id="shop_here" defaultMessage="Buy here" />,
                backgroundImage: BannerSupplies,
                backgroundImageLazy: BannerSupplies,
                routeId: 'ROUTE_CATALOG',
                queryString: '?typeId[0]=15',
                params: { outlet: '' },
                buttonColor: 'white',
                extraClassName: 'background-position-center'
            }
            homeSlides[2] = {
                title: <Translation id="warehouse" defaultMessage="Warehouse" />,
                colorTitle: 'white',
                subtitle: '',
                buttonText: <Translation id="shop_here" defaultMessage="Buy here" />,
                backgroundImage: Banner3Mktools,
                backgroundImageLazy: Banner3Mktools,
                routeId: 'ROUTE_CATALOG',
                queryString: '?webHeading[0]=WH',
                params: { outlet: '' },
                buttonColor: 'white',
                extraClassName: 'background-position-center'
            }
        }

        if(this.props.showBannerPromo) {
            homeSlides[0]['backgroundImage'] = promoNaturalStoneV2
            homeSlides[0]['title'] = <Translation id="exclusive_promo_natural_stone" defaultMessage="Exclusive promo Natural Stone" />
            homeSlides[0]['subtitle'] = <Translation id="from_14_18_november" defaultMessage="From 14-18 November" />
            homeSlides[0]['buttonText'] = <Translation id="make_a_reservation" defaultMessage="Make a reservation" />
            homeSlides[0]['URL'] = 'https://forms.cosentino.com/natural-stone-week-eu/'
        }

            return (
                <div id="home" style={{overflow: "hidden"}}>
                    {this.props.isLogging && <Spinner isLoading={this.props.isLogging} />}

                    <div className="container">
                        {this.props.maintenanceScheduledText && (
                            <Alerts status="primary" alert={<div dangerouslySetInnerHTML={{ __html: this.props.maintenanceScheduledText }} />} />
                        )}
                        <div className="home-slide-container">
                            {homeSlides.map((element, index) => {
                                // Si hay un componente personalizado, lo renderizamos directamente
                                if (element.customComponent) {
                                    return <div key={index} className={`image-slide-item${element.extraClassName ? ` ${element.extraClassName}` : ''}`}>{element.customComponent}</div>;
                                }

                                // Si hay URL externa
                                if (element.URL && element.URL !== '') {
                                    return (
                                        <a
                                            key={index}
                                            href={element.URL}
                                            className={'image-slide-item ' + element.extraClassName}
                                            target="_blank"
                                        >
                                            <div
                                                className={'image-slide-item ' + element.extraClassName}
                                                style={{
                                                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url(${element.backgroundImage})`
                                                }}
                                            >
                                                <div className="slide-title">
                                                    <div className="subtitle" style={{ color: element.colorSubtitle }}>
                                                        {element.subtitle}
                                                    </div>
                                                    <h2 className="title" style={{ color: element.colorTitle }}>
                                                        {element.title}
                                                    </h2>
                                                </div>
                                                <div className="slide-bt">
                                                    <Button
                                                        inline
                                                        gentle
                                                        size="medium"
                                                        style={{ color: element.buttonColor, borderColor: element.buttonColor }}
                                                        dataQas={element.dataQas}
                                                        gtmLabel="ec_home_banner_mosaico"
                                                    >
                                                        {element.buttonText}
                                                    </Button>
                                                </div>
                                            </div>
                                        </a>
                                    );
                                }

                                // Si no hay URL externa, usamos el Link interno
                                return (
                                    <LocalizedLink
                                        key={index}
                                        routeId={element.routeId}
                                        queryString={element.queryString}
                                        params={element.params}
                                        className={'image-slide-item ' + element.extraClassName}
                                    >
                                        <div
                                            className={'image-slide-item ' + element.extraClassName}
                                            style={{
                                                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url(${element.backgroundImage})`
                                            }}
                                        >
                                            <div className="slide-title">
                                                <div className="subtitle" style={{ color: element.colorSubtitle }}>
                                                    {element.subtitle}
                                                </div>
                                                <h2 className="title" style={{ color: element.colorTitle }}>
                                                    {element.title}
                                                </h2>
                                            </div>
                                            <div className="slide-bt">
                                                <Button
                                                    inline
                                                    gentle
                                                    size="medium"
                                                    style={{ color: element.buttonColor, borderColor: element.buttonColor }}
                                                    dataQas={element.dataQas}
                                                    gtmLabel="ec_home_banner_mosaico"
                                                >
                                                    {element.buttonText}
                                                </Button>
                                            </div>
                                        </div>
                                    </LocalizedLink>
                                );
                            })}
                        </div>

                        <div className="home-cards-container">
                            <MenuContainer customClass="home-card"></MenuContainer>
                        </div>

                        {this.props.hasPromotionLandingActivated &&
                            <Slider {...this.slickSettings} >
                                {this.props.promotionData.map(p => {
                                        const bannerTitle = p.banner_title ? (p.banner_title[this.props.locale] ? p.banner_title[this.props.locale] : p.banner_title[p.banner_title.default]) : null
                                        const bannerText = p.banner_text ? (p.banner_text[this.props.locale] ? p.banner_text[this.props.locale] : p.banner_text[p.banner_text.default]) : null

                                        return <this.CustomSlide id={p.id}
                                                                 bannerUrl={p.home_banner_url}
                                                                 bannerTitle={bannerTitle}
                                                                 bannerText={bannerText}
                                        />
                                    }
                                )}
                            </Slider>
                        }
                    </div>

                    {
                        this.props.isUsaOrCanada &&
                        <React.Fragment>
                            <div className="container dekton-banner-desktop">
                                <BannerDekton />
                            </div>
                            <div className="container dekton-banner-squared">
                                <BannerDekton squared={true} />
                            </div>
                        </React.Fragment>
                    }

                    <ProductsForYouContainer sectionFlag="HP"/>
                    {
                        // this.props.isMallPilotUser && this.props.userLandings && this.props.userLandings.length > 0 &&
                        //this.state.hasMall > 0 &&
                        <MallPreviewContainer/>
                    }
                    <LastBoughtProductsContainer sectionFlag="HB"/>
                    
                    {/* {this.props.canViewEarthicPromotion && (
                        <div className="container">
                            <BannerEarthic />
                        </div>
                    )} */}

                    {this.props.canViewSumaPromotion && (
                        <div className="container">
                            <BannerSuma />
                        </div>
                    )}

                    {this.props.canViewRockMasterPromotion && (
                        <div className="container mb-4">
                            <BannerRockMaster />
                        </div>
                    )}

                    {this.props.canViewSilestonePromotionXM && (
                        <div className="container">
                            <BannerSilestoneXM />
                        </div>
                    )}

                    {this.props.isLogged && (
                        <div className="row">
                            <div className="col-12">
                                <ChangeLogHomeNews />
                            </div>
                        </div>
                    )}
                </div>
            )
    }
}

export default injectIntl(HomeV2)
